<template>
  <div class="home-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "homeBase",
};
</script>
